<template>
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="提现银行"><el-input size="small" v-model="searchForm.bankName" placeholder="请输入提现银行"></el-input></el-form-item>
        <el-form-item label="银行卡卡号"><el-input size="small" v-model="searchForm.cardNumber" placeholder="请输入银行卡卡号"></el-input></el-form-item>
        <el-form-item label="起始时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker
              size="small"
              v-model="searchForm.createTime"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item><el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button></el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="全部" name="all"></el-tab-pane>
          <el-tab-pane :label="'待审核(' + count.audit + ')'" name="audit"></el-tab-pane>
          <el-tab-pane :label="'审核通过(' + count.pass + ')'" name="pass"></el-tab-pane>
          <el-tab-pane :label="'审核不通过(' + count.noPass + ')'" name="noPass"></el-tab-pane>
        </el-tabs>
        <el-table size="small" :data="tableData.data" border style="width: 100%" v-loading="loading">
          <!-- <el-table-column width="80px" label="头像">
            <template slot-scope="scope">
              <img :src="scope.row.avatarUrl" width="30px" height="30px" />
            </template>
          </el-table-column> -->
          <el-table-column label="用户" width="120">
            <template slot-scope="scope">
              <div>{{ scope.row.name }}</div>
              <div class="gray9">ID：({{ scope.row.userId }})</div>
            </template>
          </el-table-column>
          <el-table-column label="提现账户" width="100">
            <template slot-scope="scope">
              {{ getName(scope.row.accountType) }}
            </template>
          </el-table-column>
          <el-table-column label="提现银行" width="100">
            <template slot-scope="scope">
              {{ scope.row.bankName }}
            </template>
          </el-table-column>
          <el-table-column label="银行卡卡号" width="200">
            <template slot-scope="scope">
              {{ scope.row.cardNumber }}
            </template>
          </el-table-column>
          <el-table-column label="提现金额" width="80">
            <template slot-scope="scope">
              <div class="orange">{{ scope.row.amount }}</div>
            </template>
          </el-table-column>
          <el-table-column label="到账金额" width="80">
            <template slot-scope="scope">
              <div class="orange">{{ scope.row.receivedAmount }}</div>
            </template>
          </el-table-column>
          <el-table-column label="审核状态" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 0">待审核</span>
              <span v-if="scope.row.status == 1">审核通过</span>
              <span v-if="scope.row.status == 2">审核不通过</span>
            </template>
          </el-table-column>
          <el-table-column label="申请时间" width="150">
            <template slot-scope="scope">
              {{ scope.row.createTime }}
            </template>
          </el-table-column>
          <el-table-column label="打款方式" width="150">
            <template slot-scope="scope">
              {{ scope.row.payType=== 10?'线上': scope.row.payType=== 20?'线下':'' }}
            </template>
          </el-table-column>
          <el-table-column label="打款状态" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.payStatus == 0">待打款</span>
              <span v-if="scope.row.payStatus == 1">打款成功</span>
              <span v-if="scope.row.payStatus == 2">打款失败</span>
            </template>
          </el-table-column>
          <el-table-column label="打款时间" width="150">
            <template slot-scope="scope">
              {{ scope.row.payTime || '' }}
            </template>
          </el-table-column>
          <el-table-column label="打款结果">
            <template slot-scope="scope">
              {{ scope.row.failureReason }}
            </template>
          </el-table-column>
          <el-table-column label="打款凭证">
            <template slot-scope="scope">
              <div class="imags"  style="display: flex;justify-content: flex-start;flex-wrap: wrap;">
                <el-image v-for="(item,index) in scope.row.image" :key="index" :src="item.url" alt="" style="width:auto;height:30px;margin-right: 10px;" :preview-src-list="[item.url]" />
              </div>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button @click="addClick(scope.row)" type="text" size="small" v-auth="'/withdrawal/withdrawal/detail'">详情</el-button>
              <el-button v-if="scope.row.status == 0" @click="addClick(scope.row)" type="text" size="small">审核</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import WithdrawalApi from '@/api/withdrawal.js';
export default {
  components: {
  },
  data() {
    return {
      /*切换菜单*/
      activeName: 'all',
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      searchForm: {
        bankName: '',
        cardNumber: '',
        createTime: ''
      },
      /*统计*/
      count: {
        audit: 0,
        pass: 0,
        received: 0
      },
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      order_no: ""
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    getName(index){
      switch(index){
        case 0:
        return '旧账户'
        break;
        case 10:
        return '会员版零售利润'
        break;
        case 20:
        return '会员版伯乐奖'
        break;
        case 30:
        return '会员版团队总业绩累计考核升级制'
        break;
        case 40:
        return '会员版市场平级奖'
        break;
        case 50:
        return '会员版全国市场分红'
        break;
        case 60:
        return '创业版零售利润'
        break;
        case 70:
        return '创业版伯乐奖'
        break;
        case 80:
        return '创业版激活返现'
        break;
        case 90:
        return '创业版达标奖励'
        break;
        case 100:
        return '创业版流水分润'
        break;
        case 110:
        return '创业版平行奖励'
        break;
        case 120:
        return '创业版分红收入'
        break;
        case 130:
        return '创业版服务费返现'
        break;
        case 140:
        return '创业版流量卡返现'
        break;
        case 150:
        return '创业版股东分红返现'
        break;
        case 160:
        return '创业版周期奖励返现'
        break;
        case 170:
        return '推荐奖励'
        break;
        case 180:
        return '积分兑换'
        break;
        case 200:
        return '京东账户'
        break;
        case 999:
        return '其他账户'
        break;
        default:
          return '旧账户'
      }
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },

    /*切换菜单*/
    handleClick(tab, event) {
      let self = this;
      self.curPage = 1;
      self.getData();
    },

    /*获取列表*/
    getData() {
      let self = this;
      let search = this.searchForm;
      let Params = {};
      Params.pageIndex = self.curPage;
      Params.pageSize = self.pageSize;
      Params.dataType = self.activeName;          // 切换菜单
      if ( search.createTime != null ){
        Params.startDate = search.createTime[0];    // 开始日期
        Params.endDate = search.createTime[1];      // 结束日期
      }
      Params.bankName = search.bankName;          // 提现银行
      Params.cardNumber = search.cardNumber       // 银行卡卡号
      self.loading = true;
      WithdrawalApi.withdrawalList(Params, true)
        .then(res => {
          self.tableData.data = res.data.orderList.records;
          self.totalDataNumber = res.data.orderList.total;
          self.count = res.data.count;
          self.loading = false;
        })
        .catch(error => {});
    },
    /*打开取消*/
    cancelClick(item) {
      this.order_no = item.orderNo;
      this.open_edit = true;
    },
    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == 'edit') {
        this.open_edit = e.openDialog;
        if (e.type == 'success') {
          this.getData();
        }
      }
    },
    /*打开添加*/
    addClick(row) {
      let self = this;
      let params = row.id;
      self.$router.push({
        path: '/withdrawal/withdrawal/detail',
        query: {
          id: params
        }
      });
    },
    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.tableData = [];
      this.getData();
    },
  }
};
</script>
<style lang="scss">
.product-info {
  padding: 10px 0;
  border-top: 1px solid #eeeeee;
}

.order-code .state-text {
  padding: 2px 4px;
  border-radius: 4px;
  background: #808080;
  color: #ffffff;
}

.order-code .state-text-red {
  background: red;
}

.table-wrap .product-info:first-of-type {
  border-top: none;
}

.table-wrap .el-table__body tbody .el-table__row:nth-child(odd) {
  background: #f5f7fa;
}
</style>



// WEBPACK FOOTER //
// src/views/withdrawal/withdrawal/index.vue